import type { EClickPosition } from 'shared/constants';
import { EPageModule } from 'shared/constants';

export const sendPageShowEvent = (): void => {
  window.Tea('wap_pageshow');
};

export const sendClickEvent = (props: {
  pageModule: EPageModule;
  clickPosition: EClickPosition;
  clickId?: string;
  isCTA?: boolean;
  clickResult?: 'cancel' | 'install';
  commentId?: string;
}): void => {
  const { pageModule, clickPosition, clickId, isCTA = true, clickResult, commentId } = props;
  window.Tea('wap_click', {
    current_page_module: pageModule,
    current_position: clickPosition,
    page_click_id: clickId || null,
    is_cta: isCTA ? 1 : 0,
    comment_id: commentId,
    click_result: clickResult,
  });
};

export const sendCTAShowEvent = (props: {
  pageModule: EPageModule;
  currentPosition: EClickPosition;
  commentId?: string;
}): void => {
  const { pageModule, currentPosition, commentId } = props;

  window.Tea('wap_cta_show', {
    current_page_module: pageModule,
    current_position: currentPosition,
    comment_id: commentId || null,
  });
};

export const sendModuleShowEvent = (props: { pageModule: EPageModule; commentCount?: number }) => {
  const { pageModule, commentCount } = props;
  window.Tea('wap_module_show', {
    current_page_module: pageModule,
    comment_ctn: commentCount,
  });
};

export const sendCommentShowEvent = (props: {
  pageModule?: EPageModule.Comment;
  commentId: string;
  commentLevel: 0 | 1 | 2;
}): void => {
  const { pageModule = EPageModule.Comment, commentId, commentLevel } = props;
  window.Tea('wap_comment_show', {
    current_page_module: pageModule,
    comment_id: commentId,
    comment_level: commentLevel,
  });
};

export const sendPagePercentEvent = (props: {
  /**
   * @type {number} 0-100 integer
   */
  percent: number;
  /**
   * @type {number} 0-100 integer
   */
  picturePercent: number;
  hasOneLinkClick: boolean;
  duration: number;
}): void => {
  const { percent, picturePercent, hasOneLinkClick, duration } = props;
  window.Tea('wap_page_percent', {
    percent,
    picture_percent: picturePercent,
    has_onelink_click: hasOneLinkClick ? 1 : 0,
    duration,
  });
};
